import ScreenDesignerHoc from "./ScreenDesignerHoc";

export default ScreenDesignerHoc;